
import { Component, Vue, } from 'vue-property-decorator';
import ActionIcon from '@/components/action-icon/ActionIcon.vue';

@Component<ActionViewIcon>({
  components: {
    'action-icon': ActionIcon,
  }
})
export default class ActionViewIcon extends Vue { }
